import { apiFetch } from '../../apiFetch'

export const postPermissionAssignment = async (permission) => {
  return await apiFetch({
    method: 'POST',
    path: '/admin/permissions/assign',
    payload: permission
  })
}

export const deletePermissionAssignment = async (permission) => {
  return await apiFetch({
    method: 'DELETE',
    path: '/admin/permissions/assign',
    payload: permission
  })
}
